import { useMemo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { commonApi } from "../services/commonApi";

const stableParams = (params) => {
    return Object.keys(params || {})
        .sort((a, b) => a.localeCompare(b))
        .reduce((acc, key) => {
            acc[key] = params[key];
            return acc;
        }, {});
};

export const useMasterData = (url, params = {}) => {
    const { page, ...apiParams } = params;
    const dispatch = useDispatch();
    const stableArg = useMemo(() => ({
        url: url,
        params: apiParams && Object.keys(apiParams).length > 0 ? stableParams(apiParams) : {}
    }), [url, JSON.stringify(apiParams)]);

    const selectDropdownData = useMemo(() =>
        commonApi.endpoints.getDropdownData.select(stableArg),
        [stableArg]
    );

    const cachedResult = useSelector(selectDropdownData);

    useEffect(() => {
        if (cachedResult.status === 'uninitialized') {
            dispatch(commonApi.endpoints.getDropdownData.initiate(stableArg));
        }
    }, [stableArg, cachedResult.status, dispatch]);
    return useMemo(() => ({
        data: cachedResult.data?.data ?? [],
        isLoading: cachedResult.isLoading,
        isCached: cachedResult.status === 'fulfilled'
    }), [
        cachedResult.data?.data,
        cachedResult.isLoading,
        cachedResult.status
    ]);
};